/**
 * Custom matchAll implementation.
 *
 * As of February 2021, we still have a lot of users
 * on browsers that do not support String.prototype.matchAll
 * so we are using a custom function instead.
 */
function matchAll(pattern, haystack) {
  var regex = new RegExp(pattern, 'g');
  var matches = [];
  var matchResult = haystack.match(regex);

  if (Array.isArray(matchResult)) {
    for (var index = 0; index < matchResult.length; index++) {
      var item = matchResult[index];

      if (typeof item.match === 'function') {
        matches.push(item.match(new RegExp(pattern)));
      }
    }
  }

  return matches;
}

export { matchAll };